interface IProps {
    size?: number;
}

export const UpArrowIcon = (props: IProps) => {
    const {size} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || 16}
            height={size || 16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="m18 15-6-6-6 6"/>
        </svg>
    );
};
